import type { JSX } from 'react'

import { api } from '@setplex/tria-api'
import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { ModuleAppTitle } from '~/features/appearance'
import { STATIC_IDENTIFIERS } from '~/shared/appearance'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import { ModuleBannerCarousel } from '~/widgets/Banners/ModuleBannerCarousel'
import * as moviesModel from './model'
import { $moviesTitles } from './translations'

export function Title(): JSX.Element {
  return (
    <ModuleAppTitle identifier={STATIC_IDENTIFIERS.VOD} fallbackKey='movies' />
  )
}

const skin = era.skin('routes/movies/root')

MoviesPage.displayName = 'MoviesPage'
export function MoviesPage(): JSX.Element {
  const [
    isContentLoading,
    carousels,
    isBannersLoading,
    bannerCarouselShown,
    { detailsButtonTitle: detailsTitle },
    isEmptyPage,
  ] = useUnit([
    moviesModel.$contentLoading,
    moviesModel.$bannerCarousels,
    api.banners.getBannersFx.pending,
    moviesModel.$bannerVodCarouselShown,
    $moviesTitles,
    moviesModel.$isMoviesEmptyPage,
  ])

  // the empty state centres itself with `flexGrow`, which needs a flex parent
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className={isEmptyPage ? 'flex-column' : ''}>
        <Skeleton pageType='main' isLoading={isContentLoading}>
          {bannerCarouselShown && (
            <ModuleBannerCarousel
              carousels={carousels}
              isLoading={isBannersLoading}
              dataTestId='movies-banners'
              detailsCategoryName='Movie'
              detailsTitle={detailsTitle}
            />
          )}
          <ui.RenderSkin name='featuredCarouselTypeVod' />
          <ui.RenderSkin name='bundlesMovies' />
          <ui.RenderSkin name='movieCategories' />
          <ui.RenderSkin name='infiniteCategory' />
          <ui.RenderSkin name='moviesEmptyPage' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
